<script lang="ts">
  import {
    getUniqueByNameFirstVariations,
    getUniqueByNameSecondVariations,
    type MenuItem
  } from "../../lib/helpers/steps/menuItems";
  import Pill from "../Pill.svelte";

  export let item: MenuItem;
  export let selectedVariation: string | undefined = undefined;
  export let addMarginTop: boolean = false;

  $: firstVariations = getUniqueByNameFirstVariations(item, selectedVariation) ?? [];
  $: secondVariations = getUniqueByNameSecondVariations(item, selectedVariation) ?? [];
  $: selectedFirstVariation = selectedVariation?.split("|")[0];
  $: selectedSecondVariation = selectedVariation?.split("|")[1];
</script>

{#if firstVariations.length > 1}
  <div class="flex gap-2 flex-wrap" class:mt-5={addMarginTop}>
    {#each firstVariations as variation}
      <div class:unavailable={!variation.isAvailable}>
        <Pill
          text={variation.visible_name}
          showBorder={selectedFirstVariation === variation.name}
          grayscale={selectedFirstVariation !== variation.name} />
      </div>
    {/each}
  </div>
{/if}
{#if secondVariations.length > 1}
  <div class="flex gap-2 flex-wrap mt-2">
    {#each secondVariations as variation}
      <div class:unavailable={!variation.isAvailable}>
        <Pill
          color="blue"
          text={variation.visible_name}
          showBorder={selectedSecondVariation === variation.name}
          grayscale={selectedSecondVariation !== variation.name} />
      </div>
    {/each}
  </div>
{/if}
